<app-landing-header *ngIf="!(authService.isLoggedIn$ | async)"></app-landing-header>
<app-header *ngIf="authService.isLoggedIn$ | async"></app-header>
<div class="main-container">
  <div class="guide">
    <h1>{{ 'general.how_to_guide' | translate }}</h1>

    <div class="guide__tags">
      <app-filter-tags-label
        [label]="{ id: VIDEO_TAG_LABELS.ALL, name: 'actions.all' | translate }"
        [isActive]="selectedTags.length === 0"
        (click)="onTagClick(VIDEO_TAG_LABELS.ALL)"></app-filter-tags-label>
      <app-filter-tags-label
        [label]="{ id: VIDEO_TAG_LABELS.NEW, name: 'actions.new' | translate }"
        [isActive]="selectedTags.includes(VIDEO_TAG_LABELS.NEW)"
        (click)="onTagClick(VIDEO_TAG_LABELS.NEW)"></app-filter-tags-label>

      <ng-container *ngFor="let tag of tagsList">
        <app-filter-tags-label [label]="{ name: tag }" [isActive]="selectedTags.includes(tag)" (click)="onTagClick(tag)"></app-filter-tags-label>
      </ng-container>
    </div>

    <ng-container *ngIf="videos && videosToShow.length > 0; else emptyTemplate">
      <div class="guide__list">
        <div class="guide__list-item" *ngFor="let video of videosToShow">
          <div class="tags">
            <app-filter-tags-label
              *ngIf="video.isNew"
              [label]="{ id: VIDEO_TAG_LABELS.NEW, name: 'actions.new' | translate }"
              [isActive]="true"></app-filter-tags-label>

            <ng-container *ngIf="video.tags.length > 0">
              <app-filter-tags-label [label]="{ name: video.tags[0] }" [isActive]="true"></app-filter-tags-label>

              <div *ngIf="video.tags.length > 1" class="extra-tags" [matMenuTriggerFor]="tagTooltipMenu" [matMenuTriggerData]="{ tags: video.tags }">
                +{{ video.tags.length - 1 }}
              </div>
            </ng-container>
          </div>

          <div class="thumbnail" (click)="openVideoModal(video)">
            <img [src]="video.thumbnail" [alt]="video.title" />
            <span class="play icon-Play"></span> <span class="duration">{{ video.duration }}</span>
          </div>
          <div class="info">
            <h2>{{ video.title }}</h2>
            <p>{{ video.description }}</p>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-template #emptyTemplate>
      <div class="empty-template" *ngIf="videos">{{ 'messages.no_results.videos' | translate }}</div>
    </ng-template>
  </div>
</div>
<app-footer></app-footer>
<app-loader></app-loader>

<mat-menu #tagTooltipMenu="matMenu" class="tooltip-menu" yPosition="above" xPosition="after">
  <ng-template matMenuContent let-tags="tags">
    <ng-container *ngFor="let tag of tags | slice: 1">
      <app-filter-tags-label [label]="{ name: '' + tag }" [isActive]="true"></app-filter-tags-label>
    </ng-container>
  </ng-template>
</mat-menu>
